/**
 * @param {*} value
 * @param {*} validationValue
 * @returns {boolean}
 */
function noMatch ({ value, validationValue }) {
  return (value !== validationValue)
}

module.exports = { noMatch }
